import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    cliente: '',
    evento: '',

    imagenes: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO' (state, eventoId) {
        state.eventoId = eventoId;
        state.cliente = '';
        state.evento = '';
    
        state.imagenes = [];
    },
    'SET_EVENTO' (state, evento) {
        state.cliente = evento.cliente;
        state.evento = evento.nombre;
    },
    'SET_IMAGENES' (state, imagenes) {
        state.imagenes = imagenes;
    },
    'ADD_IMAGEN' (state, imagen) {
        state.imagenes.push(imagen);
    },
    'REMOVE_IMAGEN' (state, imagenId) {
        let itemKey = state.imagenes
            .findIndex(imagen => imagen.id == imagenId);

        if (itemKey != -1) {
            state.imagenes.splice(itemKey, 1);
        }
    },
    'UPDATE_IMAGEN' (state, params) {
        let imagen = state.imagenes
            .find(imagen => imagen.id == params.imagenId);

        if (imagen) {
            imagen.titulo = params.titulo.trim();
            imagen.descripcion = params.descripcion.trim();
        }
    },

};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO', eventoId);

            apiAxios.get('eventos/' + eventoId) 
            .then(res => {
                commit('SET_EVENTO', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getImagenes: ( { commit, state } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_IMAGENES');

            apiAxios.get('eventos/' + state.eventoId + '/imagenes' ) 
                .then(res => {
                    commit('SET_IMAGENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addImagen ( { commit, state }, params ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'jpg' 
                & fileExtension != 'png'
                & fileExtension != 'jpeg'
                & fileExtension != 'pdf') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten imágenes de tipo jpg, png o jpeg.';
            }

            if (fileSize >= 3 ) {
                error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 3MB.';
            }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);
				formData.append('main', params.main);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post('eventos/' + state.eventoId + '/imagenes', formData, options)
                    .then(res => {
                        commit('ADD_IMAGEN', res.data);
                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	
    removeImagen ( { commit, state }, imagenId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/imagenes/' + imagenId + '/delete')
                .then(() => {
					commit('REMOVE_IMAGEN', imagenId);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    updateImagen ( { commit, state  }, params ) {
        return new Promise((resolve, reject) => {
            let imagen = {
                titulo: params.titulo.trim(),
                descripcion: params.descripcion.trim()
            }
            apiAxios.post('eventos/' + state.eventoId + '/imagenes/' + params.imagenId, imagen)
                .then(() => {
					commit('UPDATE_IMAGEN', params);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}